import { createFileRoute, notFound } from "@tanstack/react-router";
import { getPage } from "@/content/pages";
import { MarkdownPage } from "@/components/MarkdownPage";
import ServiceWordpressImage from "@/assets/service-wordpress.jpg";

const PAGE_KEY = "/wordpress-websites";

export const Route = createFileRoute("/wordpress-websites")({
  loader: () => {
    const page = getPage(PAGE_KEY);
    if (!page) throw notFound();
    return page;
  },
  head: ({ loaderData }) => ({
    meta: loaderData
      ? [
          { title: loaderData.title },
          { name: "description", content: loaderData.description },
          { property: "og:title", content: loaderData.title },
          { property: "og:description", content: loaderData.description },
      { property: "og:url", content: "https://www.phil-carr.co.uk/wordpress-websites" },
        ]
      : [],
    links: [{ rel: "canonical", href: "https://www.phil-carr.co.uk/wordpress-websites" }],
  }),
  notFoundComponent: () => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-4xl">Page not found</h1>
    </div>
  ),
  errorComponent: ({ error }) => (
    <div className="container mx-auto max-w-3xl px-6 py-24 text-center">
      <h1 className="font-display text-3xl">Something went wrong</h1>
      <p className="mt-3 text-muted-foreground">{error.message}</p>
    </div>
  ),
  component: Page,
});

function Page() {
  const page = Route.useLoaderData();
  return (
    <MarkdownPage body={page.body} pageContext={page.title} heroImage={{ src: ServiceWordpressImage, alt: 'Quiet workspace with laptop, pen and notebook by a window' }} relatedSlugs={["building-a-website-that-supports-seo-and-business-growth", "why-seo-starts-with-your-website-and-always-will", "building-structured-data-and-schema-markup"]} />
  );
}
